(() => {
  const callback = () => {
    if (!window.themeComponents.snippets.register('featured-collections')) return;

    const selectors = {
      wrapper: '.featured-collections',
      swiper: '.swiper',
      swiperButtonNext: '.swiper-button-next',
      swiperButtonPrev: '.swiper-button-prev',
    };

    const initSlider = ({ targetSection } = {}) => {
      const targetSelector = targetSection ? `#${targetSection.getAttribute('id')}` : '';
      const queryString = `${targetSelector} ${selectors.wrapper} ${selectors.swiper}`;

      new Swiper(queryString, {
        slidesPerView: 2.1,
        slidesPerGroup: 1,
        spaceBetween: 5,
        freeMode: {
          enabled: true,
          sticky: true,
        },
        mousewheel: {
          forceToAxis: true,
        },
        navigation: {
          nextEl: selectors.swiperButtonNext,
          prevEl: selectors.swiperButtonPrev,
        },
        breakpoints: {
          769: {
            slidesPerView: 4,
            spaceBetween: 10,
          },
        },
        on: {
          beforeInit: function () {
            const { slidesPerView } = this?.el?.dataset;
            if (!slidesPerView) return;

            this.params.breakpoints['769'].slidesPerView = slidesPerView;
          },
        },
      });
    };
    initSlider();

    document.addEventListener('shopify:section:load', (event) => initSlider({ targetSection: event.target }));
  };

  document.addEventListener('DOMContentLoaded', callback);
})();
